// @flow
import { TOUR_PRACTICAL_INFORMATION } from 'Client/cms/toolkit/constants';
import { TourPracticalInformationLine } from 'Components/lines/tour-practical-information-line/TourPracticalInformationLine';
import { tourPracticalInformationResolver } from './tourPracticalInformation.resolver';

export const tourPracticalInformationDescriptor = {
  name: TOUR_PRACTICAL_INFORMATION,
  component: TourPracticalInformationLine,
  resolve: tourPracticalInformationResolver.resolve,
};
